import type { RoundResult } from '../shared/contracts'

type ResultLabelInput = Pick<RoundResult, 'status' | 'success' | 'profit'>

const cents = (value: number) => Math.round(value * 100) / 100

export function formatResultProfitLabel(result?: ResultLabelInput): string | undefined {
  if (!result) return undefined
  if (result.status === 'void') return 'REFUND'

  const roundedProfit = cents(result.profit ?? 0)
  if (Math.abs(roundedProfit) < 0.01) return result.success ? 'WIN' : 'LOSE'

  const sign = roundedProfit > 0 ? '+' : '−'
  return `${sign}${Math.abs(roundedProfit).toFixed(2)}$`
}

export function resultOutcomeLabel(result?: ResultLabelInput): string | undefined {
  if (!result) return undefined
  if (result.status === 'void') return 'REFUND'
  return result.success ? 'WIN' : 'LOSE'
}
